import { render, staticRenderFns } from "./PlanejamentoContratoFormFluxoAprovacao.vue?vue&type=template&id=d7b43872&scoped=true&"
import script from "./PlanejamentoContratoFormFluxoAprovacao.vue?vue&type=script&lang=js&"
export * from "./PlanejamentoContratoFormFluxoAprovacao.vue?vue&type=script&lang=js&"
import style0 from "./PlanejamentoContratoFormFluxoAprovacao.vue?vue&type=style&index=0&id=d7b43872&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7b43872",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol})
